import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

const Pagination = ({ total, page, pageSize, onPageChange, onPageSizeChange }) => {
  const { t } = useTranslation();
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-4 border-t border-slate-100" data-testid="pagination">
      <p className="text-sm text-slate-500">
        {total > 0 ? `${start}-${end} / ${total} ${t("common.records")}` : t("common.no_records")}
      </p>
      <div className="flex items-center gap-2">
        <Select value={String(pageSize)} onValueChange={(v) => { onPageSizeChange(Number(v)); onPageChange(1); }}>
          <SelectTrigger className="w-20 h-8 text-xs" data-testid="page-size-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="10">10</SelectItem>
            <SelectItem value="20">20</SelectItem>
            <SelectItem value="50">50</SelectItem>
          </SelectContent>
        </Select>
        <div className="flex items-center gap-1">
          <Button variant="outline" size="sm" className="h-8 w-8 p-0" disabled={page <= 1}
            onClick={() => onPageChange(page - 1)} data-testid="prev-page-btn">
            <CaretLeft size={14} />
          </Button>
          <span className="text-sm text-slate-600 px-2 min-w-[60px] text-center">
            {page} / {totalPages}
          </span>
          <Button variant="outline" size="sm" className="h-8 w-8 p-0" disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)} data-testid="next-page-btn">
            <CaretRight size={14} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
